import GeorgeRansom from "assets/images/psp/review-george.png";
import AnnAlarcon from "assets/images/psp/review-ann.png";
import SMurphy from "assets/images/psp/review-murphy.png";
import SevenThingsRent from "assets/images/psp/relatedContentImages/7-things-rent-storage.webp";
import LongTermStorage from "assets/images/psp/relatedContentImages/long-term-storage-cost.webp";
import SixBusiness from "assets/images/psp/relatedContentImages/6-types-business.webp";
import OutdoorParking from "assets/images/psp/relatedContentImages/outdoorparking.webp";
import HeaderBackgroundDesktop from "assets/images/psp/hero/storage-101-hero.webp";
import HeaderBackgroundMobile from "assets/images/psp/hero/storage-101-header-mobile.webp";
import HeaderBackgroundTablet from "assets/images/psp/hero/storage-101-header-tablet.webp";
import { storageCategories } from "../utils/getPSPLinks";

// ──────────────────────────────────────────────
// Reviews
// ──────────────────────────────────────────────
const reviews = {
	title: "Storage.com has 4.4 out of 5 star rating on",
	testimonials: [
		{
			body: "The person from Storage.com who assisted me was super helpful and offered several options. I saved a lot of money because of the great deals your company could offer, which were below market rate if I had dealt directly with the storage company.",
			author: "Pasadena Garden Club",
			title: "The person who assisted me was super…",
			imageSrc: GeorgeRansom
		},
		{
			body: "Abby, the customer service representative at storage.com, was professional, helpful and friendly. She found me a storage space at an excellent price in close proximity to my home. I can't thank her enough.",
			author: "Ann Alarcon",
			title: "A wonderful experience",
			imageSrc: AnnAlarcon
		},
		{
			body: "It was very easy to find storage close to me, and the selection was all mine. I was very happy with this process.",
			author: "Dale Howard",
			title: "Finding Storage",
			imageSrc: SMurphy
		}
	]
};

// ──────────────────────────────────────────────
// FAQs
// ──────────────────────────────────────────────
const faqs = [
	{
		question: "How do I choose the right storage unit size?",
		answer: "Start by making an inventory of what you are planning to store. A [5x5](https://storage.com/blog/5x5-storage-unit-size-guide/) unit is ideal for boxes and seasonal items, while inventory and business equipment may require a [10x20](https://storage.com/blog/10x20-storage-unit-size-guide/) unit. Measure your larger items with a measuring tape to determine the smallest space they can fit into. Once you have taken stock of your items, you can use [Storage.com](https://storage.com)'s storage [size guide](https://www.storage.com/self-storage-size-guide/) to find the right unit size."
	},
	{
		question: "Can I store a vehicle in a storage unit?",
		answer: "Yes, you can store vehicles in storage units. Many facilities offer various storage options such as indoors, outdoors, and covered storage for cars, RVs, boats, trailers, and more. Be sure to check size requirements and accessibility with the storage facility, especially for larger vehicles."
	},
	{
		question: "What can I keep in a self-storage unit?",
		answer:
			"There are a number of common items that can be placed in a storage unit, including:\n" +
			"- Furniture\n" +
			"- Household goods (artwork, books, home decor, etc.)\n" +
			"- Sports equipment\n" +
			"- Seasonal items\n" +
			"- Commercial goods\n" +
			"- Electronics\n" +
			"- Appliances\n" +
			"- Cars, boats, motorcycles, and RVs\n" +
			"- Alcohol"
	},
	{
		question: "What can't I keep in a self-storage unit?",
		answer:
			"There are quite a few things that you can't put in your self-storage unit, such as:\n" +
			"- Priceless items that cannot be replaced\n" +
			"- Money\n" +
			"- Live animals or plants\n" +
			"- Stolen property\n" +
			"- Hazardous materials\n" +
			"- Noxious materials\n" +
			"- Flammable materials\n" +
			"- Perishable items, like food\n" +
			"- Illegal drugs\n" +
			"- Explosives and dangerous materials\n" +
			"- Firearms, ammunition or weapons caches\n" +
			"- Unregistered or uninsured vehicles\n" +
			"- Tires\n" +
			"- Furs\n" +
			"- Wet items\n" +
			"- Humans"
	},
	{
		question: "What types of businesses use self-storage?",
		answer:
			"With the flexibility to scale as business needs evolve, self-storage is ideal for:\n" +
			"- Small businesses looking for a cost-effective storage solution;\n" +
			"- E-commerce retailers with fluctuating inventory levels; and\n" +
			"- Service providers needing flexible, accessible space for equipment or documents.\n\n" +
			"[Learn more about types of business storage solutions here.](https://storage.com/blog/types-of-business-storage/)"
	}
];

// ──────────────────────────────────────────────
// Related Content
// ──────────────────────────────────────────────
const relatedContentCards = [
	{
		content: "7 Things to Expect When You Rent a Storage Unit",
		category: "Self Storage",
		date: "May 22, 2025",
		url: "https://www.storage.com/blog/what-to-expect-when-renting-storage-unit/",
		image: SevenThingsRent
	},
	{
		content: "A Quick Guide to Long Term Storage Costs",
		category: "Self Storage",
		date: "August 16, 2025",
		url: "https://www.storage.com/blog/long-term-storage-cost/",
		image: LongTermStorage
	},
	{
		content: "6 Types of Business Storage: Best Uses and Features",
		category: "Storage for Business",
		date: "October 14, 2025",
		url: "https://www.storage.com/blog/types-of-business-storage/",
		image: SixBusiness
	},
	{
		content: "How Much Does Vehicle Storage Cost?",
		category: "Self Storage",
		date: "September 8, 2025",
		url: "https://www.storage.com/blog/cost-of-car-storage/",
		image: OutdoorParking
	}
];

const storageHerodescription = `
Whether you’re storing your equipment, expanding your business, or going through a major life change, self-storage offers the flexibility and space to support your goals. Storage.com makes it easy to search, compare, and reserve self-storage units near you in minutes. Find the right unit size, amenities, and price all in one place, and we’ll take care of the rest.
`;

export const PSPSelfStorageContent = {
	type: "Self",
	sections: [
		{
			title: "selfStorage hero",
			noPadding: true,
			modules: [
				{
					type: "hero-section",
					props: {
						title: "Find the Top Storage Units",
						description: storageHerodescription,
						searchPlaceholder: "Search by city, state, or zip...",
						buttonText: "Find Storage Units",
						heroImages: {
							desktop: HeaderBackgroundDesktop,
							tablet: HeaderBackgroundTablet,
							mobile: HeaderBackgroundMobile
						},
						heroAltText: "Self Storage Hero Image"
					}
				}
			]
		},
		// ── 1. Size Comparison ──────────────────────
		{
			title: "Find Your Perfect Fit: Storage Size Comparison",
			noPadding: true,
			modules: [
				{
					type: "size-comparison",
					props: {
						pageType: "psp",
						title: "Find Your Perfect Fit: Storage Size Comparison",
						description:
							"Traditional storage units come in an array of sizes, ranging from space equivalent to a coat closet to those large enough to store the contents of an entire home.",
						sizes: [
							{
								id: "5x5",
								label: "5x5",
								title: "5' Wide x 5' Long",
								description:
									"- Fits a dresser, small mattress set, and several boxes\n" +
									"- Great for creating additional space for those living in studios or apartments\n" +
									"- Many store seasonal items, gardening tools, and clothing inside"
							},
							{
								id: "5x10",
								label: "5x10",
								title: "5' Wide x 10' Long",
								description:
									"- Fits a queen-sized mattress, dresser, TV, and several boxes\n" +
									"- Great choice for college students, sharing a unit, and seasonal storage\n" +
									"- Often used as temporary storage during a move, or to store larger recreational items like sports gear"
							},
							{
								id: "10x10",
								label: "10x10",
								title: "10' Wide x 10' Long",
								description:
									"- Fits an entire family room and full bedroom set (even more with strategic organization!)\n" +
									"- Ideal for large items and appliances\n" +
									"- Good choice for compact recreational vehicles like jetskis or motorcycles"
							},
							{
								id: "10x15",
								label: "10x15",
								title: "10' Wide x 15' Long",
								description:
									"- Fits multiple bedroom sets, plus additional furniture pieces like sofas, chairs, and appliances\n" +
									"- Good for apartment storage, small home storage, and more\n" +
									"- Good option for small vehicle, scooter, and golf cart storage"
							},
							{
								id: "10x20",
								label: "10x20",
								title: "10' Wide x 20' Long",
								description:
									"- Fits contents of a medium to large house, plus several boxes\n" +
									"- Popular choice for moving, car storage, and business storage use\n" +
									"- Among the largest commonly available storage unit size"
							},
							{
								id: "10x30",
								label: "10x30",
								title: "10' Wide x 30' Long",
								description:
									"- Fits contents of a large home, including furniture, appliances, and boxes of valuables\n" +
									"- Popular choice for indoor vehicle storage, with additional space for some accessories\n" +
									"- Good option for business inventory storage"
							}
						]
					}
				}
			]
		},

		// ── 2. Rich Content Section ─────────────────
		{
			title: "Business or Personal: There's a Storage Option for Everyone",
			noPadding: true,
			modules: [
				{
					type: "video-content",
					props: {
						title: "Business or Personal: There's a Storage Option for Everyone",
						additionalContent: true,
						textAlign: "center",
						description: `Storage is built for flexibility.`,
						markDown: `

Homeowners use it to manage space during renovations or moves. Business owners use it to manage inventory, documents, and equipment. 

Commercial operations use it for off-site tools storage and logistics support. 

No matter the scale or scope, Storage.com helps you compare unit sizes, features, and rates so you can pick the right one for your needs.`,
						mediaType: "video",
						mediaUrl: "tmS_BvBjBwI",
						videoTitle:
							"Business or Personal: There's a Storage Option for Everyone"
					}
				}
			]
		},

		// ── 3. Rich Content Section 2 ───────────────
		{
			title: "Short term vs Long term Storage: What's Right for You?",
			noPadding: true,
			modules: [
				{
					type: "video-content",
					props: {
						title: "Short term vs Long term Storage: What's Right for You?",
						additionalContent: true,
						textAlign: "center",
						markDown: `Short term storage offers flexible month-to-month rental without a long commitment, and thus is ideal for transitions—moving, renovating, or storing seasonal items. [Long term storage](https://storage.com/blog/long-term-storage-cost/) provides better pricing for longer leases, which works well for ongoing needs—storing business inventory, parking a vehicle offsite, or archiving records.`,
						mediaType: "video",
						mediaUrl: "ezOucva5TzQ",
						videoTitle:
							"Short term vs Long term Storage: What's Right for You?"
					}
				}
			]
		},

		// ── 4. Inline CTA ───────────────────────────
		{
			title: "Self Storage CTA",
			noPadding: true,
			modules: [
				{
					type: "inline-cta",
					props: {
						storageType: "Self"
					}
				}
			]
		},

		// ── 5. Reviews ──────────────────────────────
		{
			title: "Self Storage Reviews",
			noPadding: true,
			modules: [
				{
					type: "reviews",
					props: reviews
				}
			]
		},

		// ── 6. FAQs ─────────────────────────────────
		{
			title: "Self Storage FAQs",
			noPadding: true,
			modules: [
				{
					type: "faq",
					props: {
						title: "Self Storage FAQs",
						faqs
					}
				}
			]
		},

		// ── 7. Related Content ──────────────────────
		{
			title: "Self Storage Related Content",
			noPadding: true,
			modules: [
				{
					type: "related-content",
					props: {
						heading: "Learn More About Storage",
						unitCards: relatedContentCards
					}
				}
			]
		},

		// ── 10. Link to Other PSPs ──────────────────
		{
			title: "Links to other PSP",
			noPadding: true,
			modules: [
				{
					type: "psp-links",
					props: {
						background: "white",
						storageGridContent: {
							title: "More Ways to Store",
							storageTypes: storageCategories.selfStorage
						}
					}
				}
			]
		},

		// ── 11. Nearby Cities ───────────────────────
		{
			title: "Self Storage Near You",
			noPadding: true,
			modules: [
				{
					type: "nearby-cities",
					props: {
						pageType: "PSP",
						background: "light-blue"
					}
				}
			]
		}
	]
};

export default PSPSelfStorageContent;
